import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuth';

const API_URL = 'https://nwt.am';export default function AdminDashboard() {
    const { admin } = useAdminAuth();
    const [stats, setStats] = useState({ posts: 0 });

    useEffect(() => {
        fetch(`${API_URL}/posts/admin`, {
            headers: { 'Authorization': `Bearer ${admin.token}` }
        })
        .then(res => res.json())
        .then(data => setStats({ posts: data.length }))
        .catch(() => {});
    }, [admin]);

    return (
        <div>
            <h1 className="text-3xl font-black text-[#0B3B6F] uppercase mb-8">Dashboard</h1>
            
            <div className="grid gap-6 md:grid-cols-3">
                <div className="bg-white p-6 shadow-sm">
                    <p className="text-4xl font-black text-[#0FA4E8]">{stats.posts}</p>
                    <p className="text-sm text-slate-500 mt-2 uppercase">Նորություններ</p>
                    <Link to="/admin/posts" className="text-xs text-[#0FA4E8] mt-4 block">Կառավարել →</Link>
                </div>
            </div>
        </div>
    );
}